import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "label"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { FormControl } from '@mui/material';
import { CheckedIcon, Icon, StyledFormControlLabel, StyledRadio } from './radio.styles';
import { jsx as _jsx } from "react/jsx-runtime";
var Radio = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var size = _ref.size,
    label = _ref.label,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(FormControl, {
    component: "fieldset",
    children: /*#__PURE__*/_jsx(StyledFormControlLabel, {
      label: label,
      labelPlacement: "end",
      size: size,
      control: /*#__PURE__*/_jsx(StyledRadio, _objectSpread({
        ref: ref,
        size: size,
        checkedIcon: /*#__PURE__*/_jsx(CheckedIcon, {
          size: size
        }),
        icon: /*#__PURE__*/_jsx(Icon, {
          size: size
        })
      }, restProps))
    })
  });
});
Radio.displayName = 'Radio';
export { Radio };